import axios from "axios"

interface ICheckStopSellParams {
    bookingId: string
}

interface ICheckStopSellReturn {
    stopSell: boolean,
    ignore: boolean,
    stopOverbooking: boolean,
}

export const checkStopSell = async (params: ICheckStopSellParams): Promise<ICheckStopSellReturn> => {
    const response = await axios.get(`/booking/book/${params.bookingId}/check-stop-sell`);
    return response.data;
}